
import * as types from './actionTypes';

// Action creators for basic details
export const getBasicDetails = (payload: {}) => ({ type: types.GET_BASIC_DETAILS, payload });
export const saveBasicDetails = (payload: {}) => ({ type: types.GET_BASIC_DETAILS_SUCCESS, payload })

export const getReviewNegotiationData = () => ({ type: types.GET_REVIEW_NEGOTIATION_DATA })

export const getTargetValueDetails = (payload: {}) => ({ type: types.GET_TARGET_VALUE_DETAILS, payload });
export const saveTargetValueDetails = (payload: {}) => ({ type: types.GET_TARGET_VALUE_DETAILS_SUCCESS, payload });

export const getSelectedActionTiles = (payload: {}) => ({ type: types.GET_SELECTED_ACTION_TILES, payload });
export const saveSelectedActionTiles = (payload: {}) => ({ types: types.GET_SELECTED_ACTION_TILES_SUCCESS, payload })

export const addNegoAction = (payload: {}) => ({ types: types.ADD_NEGOTIATION_ACTION_SUCCESS, payload });
export const deleteNegoAction = (payload: {}) => ({ types: types.DELETE_NEGOTIATION_ACTION_SUCCESS, payload });

export const createNewSupplier = (payload: {}) => ({ types: types.CREATE_NEW_SUPPLIER_SUCCESS, payload });

export const deleteNewSupplier = (payload: {}) => ({ types: types.DELETE_SUPPLIER_SUCCESS, payload });

export const createNewSalesRepLead= (payload: {}) => ({ types: types.CREATE_NEW_SALES_REP_LEAD_SUCCESS, payload });

export const deleteSalesRepLead = (payload: {}) => ({ types: types.DELETE_SALES_REP_LEAD_SUCCESS, payload });

export const saveNegotiationRoundActions = (roundName: string, selectedActions: any[]) => (
    {
        type: types.SAVE_NEGOTIATION_ROUND_ACTIONS,
        payload: { roundName, selectedActions }
    }
)
// Action creators for basic details dropdown api 
export const getNegotiationActions = () => ({ type: types.GET_NEGOTIATION_ACTIONS })
export const getNegotiationActionRelation = () =>({type:types.GET_NEGOTIATION_ACTION_RELATION})
export const saveNegotiationActions = (payload: {}) => ({ type: types.GET_NEGOTIATION_ACTIONS_SUCCESS, payload })
export const getCountriesDropdownAction = () => ({ type: types.GET_BASIC_DETAILS_COUNTRIES })
export const getCatagoriesDropdownAction = () => ({ type: types.GET_BASIC_DETAILS_CATAGORIES })
export const getSuppliersDropdownAction = () => ({ type: types.GET_BASIC_DETAILS_SUPPLIERS })
export const getSalesRepLeadAction = (id: string) => ({ type: types.GET_BASIC_DETAILS_SALESREPLEAD })
export const getEntraIDUsers = (searchText:string) => ({ type: types.GET_ENTRA_ID_USERS})


//Action creators for power position 
export const getPowerPosition = (payload: {}) => ({ type: types.GET_POWER_POSITION, payload });
export const savePowerPosition = (payload: any) => ({ type: types.GET_POWER_POSITION_SUCCESS, payload })
export const getPowerPositionList = ()=> ({type:types.GET_POWER_POSITION_LIST});
export const getAISuggestionForPowerPosition = (payload: any) => ({ type: types.GET_AI_SUGGESTION_DATA_POWER_POSITION, payload })
export const getAISuggestionForActionCards = (payload: any) => ({ type: types.GET_AI_SUGGESTION_FOR_ACTION_CARDS, payload })

export const saveDocumentOutcome = (payload: any) => ({ type: types.SAVE_DOCUMENT_OUTCOME, payload })
export const getDocumentOutcome =(payload:any)=>({type:types.GET_DOCUMENT_OUTCOME,payload})
// action creator for sales rep classicafication type
export const saveClassicationType = (payload: {}) => ({ type: types.SET_CLASSIFICATION_TYPE, payload })
export const getAIDataForSalesPrep = (payload: any) => ({ type: types.GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION, payload })

// action creator for toast message 
export const apiCallRequest = () => ({ type: types.API_CALL_REQUEST })
export const apiCallSuccess = (payload: {}) => ({ type: types.API_CALL_SUCCESS, payload })
export const apiCallFailure = (payload: {}) => ({ type: types.API_CALL_FAILURE, payload })
export const clearApiCallMessage = () => ({ type: types.CLEAR_API_CALL_MESSAGE })



// action creator for sales rep classicafication type
export const createNegotiation = (payload: {}) => ({ type: types.CREATE_NEGOTIATION, payload })
export const getSalesRepClassificationList = () => ({type:types.GET_SALES_REP_CLASSIFICATION_LIST})

// action creator for profile page
export const getProfileDetails = (payload: {}) => ({ type: types.GET_PROFILE_DETAILS, payload });
export const saveProfileDetails = (payload: {}) => ({ type: types.GET_PROFILE_DETAILS_SUCCESS, payload });
export const updateProfileDetails = (payload: {}) => ({ type: types.UPDATE_PROFILE_DETAILS, payload });
//action creator for overview page negotiation data 
export const getNegotiationContracts = () => ({ type: types.GET_ALL_NEGOTIATION_CONTRACTS })

//action creators for negotiation tile draft flow
export const getNegotiationTileDataAction = (payload: any) => ({ type: types.GET_NEGOTIATION_TILE_DETAILS, payload })
export const resetDraftNavigation = () => ({ type: types.GET_NEGOTIATION_TILE_DETAILS_FAILURE })

// action creators for setting contract status for overview page navigation 
export const setNegotiationContractStatus = (payload: any) => ({ type: types.SET_NEGOTIATION_CONTRACT_STATUS, payload });

//action creators for details negotiation overview page 
export const saveDetailedNegotiationOverviewAction = (payload: any) => ({ type: types.POST_DETAILED_NEGOTIATION_OVERVIEW, payload });
export const resetDetailedNegotiationOverviewPage = () => ({ type: types.RESET_DETAILED_NEGOTIATION_OVERVIEW });


// action creators for close negotiation AI summary 
export const getAISummaryForCloseNegotiationAction = (payload:any)=>({type:types.GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION,payload})